import React from 'react';
import './../quizz/style/fonts.module.css';

const PageCenter = ({ light, theme, justifyCenter, children }) => {
  return (
    <div
      
    > 
      {children}
    </div>
  );
};

export default PageCenter;